import useSWRMutation from 'swr/mutation';
import { postData } from '@apis/rest-client';

const DataReviewTableApi = {
    usePreview: (studyRef: string) => {
        return useSWRMutation(
            `CentralMonitoring/datareviewtable/${studyRef}/preview`,
            (url: string, { arg }: { arg: string }) => {
                return postData<string, string>(url, { arg, timeout: 30000 });
            },
        );
    },
};

export default DataReviewTableApi;
